import { gql } from "@urql/core";

export type FlowPickerSpaceQuery = {
  documentSpace?: {
    documentSpaceSections: {
      nodes: Array<{
        documentSpaceItemsBySectionId: {
          nodes: Array<{
            flow?: {
              id: string;
            } | null;
          } | null>;
        };
      } | null>;
    };
  } | null;
};

export const FlowPickerSpaceDocument = gql`
  query FlowPickerSpace($id: BigInt!) {
    documentSpace(id: $id) {
      documentSpaceSections {
        nodes {
          documentSpaceItemsBySectionId(filter: { flowId: { isNull: false } }) {
            nodes {
              flow {
                id
              }
            }
          }
        }
      }
    }
  }
`;
